<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<style>
  .side-image {
      margin: 0px auto;
      width: 100%;
  }

  /* `lg` applies to medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
      .side-image {
          margin: 0px;
          width: 100%;
      }
  }
</style>

<section class="features">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <div class="row">

      <div class="col-lg-6">
        <img class="side-image d-block" src="{image(block, 'picture', [800, null])}"
             alt="">
      </div>

      <div class="col-lg-6 mt-5 mt-lg-0 d-flex">
        <div class="row align-self-center gy-4 mb-3">

          {#each blocklist(block, 'featuresList') as item}
          <div class="col-md-6" data-aos="zoom-out" data-aos-delay="200">
            <a href="{url(item, 'link')}">
              <div class="feature-box d-flex align-items-center">
                <i class="bi bi-check"></i>
                <h3>{text(item, 'title')}</h3>
              </div>
            </a>
          </div>
          {/each}

        </div>
      </div>

    </div> <!-- / row -->

  </div>

</section>
